import { AddBoxOutlined, AddCircleOutlined, AnalyticsOutlined, CancelOutlined, CategoryOutlined, CheckCircleOutlineOutlined, ContactsOutlined, DashboardCustomizeOutlined, EditOutlined, EventNoteOutlined, FormatListBulletedOutlined, HistoryOutlined, HouseOutlined, HouseSidingOutlined, ListOutlined, ManageAccountsOutlined, PeopleOutlined, RateReview, RateReviewOutlined } from "@mui/icons-material";
import SupportedAuthProviders from "../MicrospecDynamicUI/Auth/MicrospecSupportedAuthProvider";
import AddCategory from "./dashboards/admins/AddCategory";
import AddUser from "./dashboards/admins/AddUser";
import AdminDashboard from "./dashboards/admins/AdminDashboard";
import ManageUsers from "./dashboards/admins/ManageUsers";
import ApprovedProperties from "./dashboards/admins/ApprovedProperties";
import DeclinedProperties from "./dashboards/admins/DeclinedProperties";
import ManageCategories from "./dashboards/admins/ManageCategories";
import PropertiesInReview from "./dashboards/admins/PropertiesInReview";
import AddProperty from "./dashboards/owners/AddProperty";
import ManageAppointments from "./dashboards/owners/ManageAppointments";
import ManageClients from "./dashboards/owners/ManageClients";
import PastAppointments from "./dashboards/owners/PastAppointments";
import ManageProperties from "./dashboards/owners/ManageProperties";
import MainPage from "./pages/MainPage";
import OwnersDashboard from "./pages/OwnersDashboard";
import OwnersPublicPage from "./pages/OwnersPublicPage";
import PropertyPublicPage from "./pages/PropertyPublicPage";

const config = {
    application: {
        name: "عقاركو - منصة العقارات",
        logo: "/static/images/akarko-transparent-logo.svg",
        showApplicationNameInDashboard: false,
        auth: {
            enableRegister: true,
            enabledProviders: [
                SupportedAuthProviders.EMAIL,
            ],
            verificationRequired: true,
            rolesAssigned: [
                "owner"
            ],
            userProfile: {
                additionalData: [
                    {
                        key: "address",
                        displayName: {
                            type: "Internal",
                            text: "address"
                        },
                        type: "text", // text or numeric
                        defaultValue: "", // optional
                        multiline: false,
                        required: true
                    },
                    {
                        key: "yearsOfExperience",
                        displayName: {
                            type: "Internal",
                            text: "yearsOfExperience"
                        },
                        type: "number", // text or numeric
                        defaultValue: 0, // optional
                        minValue: 0,
                        required: false
                    },
                    {
                        key: "about",
                        displayName: {
                            type: "Internal",
                            text: "aboutYourself"
                        },
                        type: "text", // text or numeric
                        defaultValue: "", // optional
                        multiline: true, // true or false only if type is string
                        required: false
                    }
                ]
            }
        },
        commonConfig: {
            showOfflineDialog: false,
        },
        theme: {
            mode: "light",
            primary: {
                main: "#046878",
                light: "#378a9e",
                dark: "#004851",
                contrastText: "#ffffff"
            },
            secondary: {
                // a color comptabile with #008489
                // main: "#ddd8ca"
                main: "#BFC9CA",
                light: "#E3E9EA",
                dark: "#AAB2B4",
                contrastText: "#000000"
            },
        }
    },
    pages: [
        {
            path: '/',
            spec: {
                type: "Simple",
                object: <MainPage />
            }
        },
        {
            path: '/property/:propertyId',
            spec: {
                type: "Simple",
                object: <PropertyPublicPage />
            }
        },
        {
            path: '/owner/:ownerId',
            spec: {
                type: "Simple",
                object: <OwnersPublicPage />
            }
        },
    ],
    dashboards: [
        {
            path: "/admin",
            name: {
                type: 'Literal',
                text: 'إدارة النظام',
            },
            roles: ['admin'],
            items: [
                {
                    path: 'dashboard',
                    name: {
                        type: 'Literal',
                        text: 'لوحة التحكم الرئيسية',
                    },
                    icon: <AnalyticsOutlined />,
                    hide: false,
                    spec: {
                        type: 'Simple',
                        object: <AdminDashboard />,
                    },
                },
                {
                    path: 'properties',
                    name: {
                        type: 'Literal',
                        text: 'العقارات',
                    },
                    icon: <HouseOutlined />,
                    hide: false,
                    specs: [
                        {
                            path: 'manage',
                            name: {
                                type: 'Literal',
                                text: 'إدارة العقارات',
                            },
                            icon: <HouseSidingOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <ManageProperties includeOwnerIdQuery={false} enableOwnersActions={false} />,
                            }
                        },
                    ]
                },
                {
                    path: 'review',
                    name: {
                        type: 'Literal',
                        text: 'مراجعة العقارات',
                    },
                    icon: <RateReviewOutlined />,
                    hide: false,
                    specs: [
                        {
                            path: 'under-review',
                            name: {
                                type: 'Literal',
                                text: 'عقارات تحت المراجعة',
                            },
                            icon: <RateReview />,
                            spec: {
                                type: 'Simple',
                                object: <PropertiesInReview />,
                            }
                        },
                        {
                            path: 'declined',
                            name: {
                                type: 'Literal',
                                text: 'عقارات مرفوضة',
                            },
                            icon: <CancelOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <DeclinedProperties />,
                            }
                        },
                        {
                            path: 'approved',
                            name: {
                                type: 'Literal',
                                text: 'عقارات موافق عليها',
                            },
                            icon: <CheckCircleOutlineOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <ApprovedProperties />,
                            }
                        }
                    ]
                },
                {
                    path: 'categories',
                    name: {
                        type: 'Literal',
                        text: 'الفئات',
                    },
                    icon: <CategoryOutlined />,
                    hide: false,
                    specs: [
                        {
                            path: 'add',
                            name: {
                                type: 'Literal',
                                text: 'إضافة فئة',
                            },
                            icon: <AddCircleOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <AddCategory />,
                            }
                        },
                        {
                            path: 'edit/:categoryId',
                            name: {
                                type: 'Literal',
                                text: 'تعديل فئة',
                            },
                            icon: <EditOutlined />,
                            hide: true,
                            spec: {
                                type: 'Simple',
                                object: <AddCategory />,
                            }
                        },
                        {
                            path: 'manage',
                            name: {
                                type: 'Literal',
                                text: 'إدارة الفئات',
                            },
                            icon: <FormatListBulletedOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <ManageCategories />,
                            }
                        }
                    ]
                },
                {
                    path: 'users',
                    name: {
                        type: 'Literal',
                        text: 'المستخدمين',
                    },
                    icon: <PeopleOutlined />,
                    hide: false,
                    specs: [
                        {
                            path: 'edit/:userId',
                            name: {
                                type: 'Literal',
                                text: 'تعديل مستخدم',
                            },
                            icon: <EditOutlined />,
                            hide: true,
                            spec: {
                                type: 'Simple',
                                object: <AddUser />,
                            }
                        },
                        {
                            path: 'manage',
                            name: {
                                type: 'Literal',
                                text: 'إدارة المستخدمين',
                            },
                            icon: <ManageAccountsOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <ManageUsers />,
                            }
                        }
                    ]
                }
            ],
        },
        {
            path: "/owners",
            name: {
                type: 'Literal',
                text: 'مُلَّاك العقارات',
            },
            roles: ['normal'],
            items: [
                {
                    path: 'dashboard',
                    name: {
                        type: 'Literal',
                        text: 'لوحة التحكم',
                    },
                    icon: <DashboardCustomizeOutlined />,
                    hide: false,
                    spec: {
                        type: 'Simple',
                        object: <OwnersDashboard />,
                    },
                },
                {
                    path: 'properties',
                    name: {
                        type: 'Literal',
                        text: 'عقاراتي',
                    },
                    icon: <HouseOutlined />,
                    hide: false,
                    specs: [
                        {
                            path: 'manage',
                            name: {
                                type: 'Literal',
                                text: 'إدارة العقارات',
                            },
                            icon: <ListOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <ManageProperties includeOwnerIdQuery={true} enableOwnersActions={true} />,
                            }
                        },
                        {
                            path: 'add',
                            name: {
                                type: 'Literal',
                                text: 'اضافة عقار',
                            },
                            icon: <AddBoxOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <AddProperty />,
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: {
                                type: 'Literal',
                                text: 'تعديل عقار',
                            },
                            icon: <EditOutlined />,
                            hide: true,
                            spec: {
                                type: 'Simple',
                                object: <AddProperty />,
                            }
                        },
                    ]
                },
                {
                    path: 'clients',
                    name: {
                        type: 'Literal',
                        text: 'عملائي',
                    },
                    icon: <ContactsOutlined />,
                    hide: false,
                    specs: [
                        {
                            path: 'manage',
                            name: {
                                type: 'Literal',
                                text: 'إدارة العملاء',
                            },
                            icon: <ListOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <ManageClients />,
                            }
                        },
                        {
                            path: 'appointments',
                            name: {
                                type: 'Literal',
                                text: 'إدارة المواعيد',
                            },
                            icon: <EventNoteOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <ManageAppointments />,
                            }
                        },
                        {
                            path: 'past-appointments',
                            name: {
                                type: 'Literal',
                                text: 'المواعيد السابقة',
                            },
                            icon: <HistoryOutlined />,
                            spec: {
                                type: 'Simple',
                                object: <PastAppointments />,
                            }
                        },
                    ]
                }
            ],
        },
    ],
    languages: {
        default: 'ar-SA',
        list: [
            { code: 'ar-SA', name: 'العربية' },
        ]
    }
}

export default config;